<template>
  <el-card class="panel-card" shadow="never">
    <template #header>
      <div class="card-header">
        <span>请求地址</span>
        <el-tag type="success" effect="plain">OpenAI Compatible</el-tag>
      </div>
    </template>
    <el-alert type="info" :closable="false" show-icon>
      <template #title>
        <span>OpenAI 兼容接口地址：</span>
        <code>{{ endpoint }}</code>
      </template>
    </el-alert>
  </el-card>
</template>

<script>
export default {
  name: 'EndpointSection',
  props: {
    endpoint: {
      type: String,
      required: true
    }
  }
}
</script>
